import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStyleshareComponent } from './simple-icons-styleshare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStyleshareComponent ],
    exports:      [ SimpleIconsStyleshareComponent ],
    bootstrap:    []
})
export class SimpleIconsStyleshareModule {}
